
import addPrefix from 'bwax-ui/addPrefix'

import Tabs from './Tabs'
import PageContent from './PageContent'

export default addPrefix('templates', {
    Tabs,
    PageContent
})